import * as tslib_1 from "tslib";
import HLabel from "../../../../../form/src/common/components/label.vue";
import { labelText } from "../../../../../form/src/schema/system-data-item-codes";
import { Component, Prop, Vue } from "vue-property-decorator";
let Modifier = class Modifier extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], Modifier.prototype, "control", void 0);
Modifier = tslib_1.__decorate([
    Component({
        name: 'Modifier',
        components: {
            HLabel: HLabel
        }
    })
], Modifier);
export default Modifier;
